import { render } from "./InputIconRight.vue?vue&type=template&id=5d628a8e&ts=true"
import script from "./InputIconRight.vue?vue&type=script&lang=ts"
export * from "./InputIconRight.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__